import type { ReactNode } from "react";
import {
  TicketTag,
  CampingTag,
  GiftTag,
  CinemaTag,
  ParkTag,
  PartnerTag,
  DiscountTag,
} from "@/features/shop";

const getTagComponent = (tag: string): ReactNode | undefined => {
  switch (tag) {
    case "ticket":
      return <TicketTag />;
    case "camping":
      return <CampingTag />;
    case "gift":
    case "cadeau":
      return <GiftTag />;
    case "cinema":
      return <CinemaTag />;
    case "park":
    case "parc":
      return <ParkTag />;
    case "partner":
    case "partenaire":
      return <PartnerTag />;
    case "discount":
      return <DiscountTag discount={0} />;
    default:
      return undefined;
  }
};

export const mapTagStringToComponent = (tag?: string): ReactNode | undefined => {
  const normalizedTag = tag?.toLowerCase().trim();
  if (!normalizedTag) {
    return undefined;
  }

  return getTagComponent(normalizedTag);
};
